module.exports = __webpack_public_path__ + "img/jerk_sandwich_veg.fd639ba4.jpg";